<template>
  <div>
    <v-tooltip v-if="label" top>
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <img
            :src="srcPath"
            :width="size"
            :height="size"
            class="img-contain"
          />
        </div>
      </template>
      <span>{{ label }}</span>
    </v-tooltip>
    <img v-else :src="srcPath" :width="size" :height="size" />
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  export default {
    name: 'SvgIcon',
    props: {
      size: { type: [String, Number], default: 24 },
      name: {
        // file name widthout extension, saved in @/assets/icons/
        type: String,
        required: true,
      },
      label: {
        type: String,
      },
    },
    computed: {
      srcPath() {
        // only svg images
        return require(`@/assets/icons/${this.name}.svg`);
      },
    },
  };
</script>
